import React from 'react';
import { settings } from '../../config/settings';
import ControlService from '../../helper/controlservice';
import { fetchUploadApi } from '../../helper/common/upload';

export const AzureImageAnalysis = (token, control, fileUrl, props, formid) => {
    let _control = {
        datasource: 'http',
        method: 'post'
    };
    ControlService().ServiceRequest(ControlService().azureFunctionUrl(token) + "/api/azure/computervision/" + control.azureimageanalysistype, { urlFile: fileUrl, fnname: control.azureimageanalysistype }, _control, props.token, {})
        .then(
            (res) => {
                props.update(control.imageanalysisresponsekey ? control.imageanalysisresponsekey : (control.key + '_imageanalysis'), res.data, formid);
            })
        .catch(err => {
            console.log(err);
        });
}
export const GoogleImageAnalysis = (token, control, files, props, formid, fnname) => {
    let formData = new FormData();
    var filename = "";
    for (var i = 0; i < files.length; i++) {
        formData.append(files[i].name, files[i]);
        filename = files[i].name;
    }
    var method = 'POST';
    const headers = new Headers();
    headers.append('Authorization', 'bearer ' + props.token.accesstoken);
    headers.append("api-key", props.token.apikey);
    fetchUploadApi(ControlService().azureFunctionUrl(token) + settings.GOOGLE_DOC_AI_API + '/' + fnname, method, headers, formData)
        .then(res => {
            var response = res.data;
            var resultdata = {};
            if (response.fileurl) {
                resultdata = response.fileurl;
            }
            var data = props.data[formid];
            if (!control.uploadtype || control.uploadtype == 'single') {
                data[control.key] = resultdata;
                props.update(control.key + "_name", filename, formid);
                props.update(control.key + "_url", resultdata, formid);

                props.update(control.key, data[control.key], formid);
            }
            let docairesponse = response.docairesponse;
            if (typeof docairesponse == 'object' && docairesponse.error) {
                // ControlService().toastError(docairesponse.error.message, docairesponse.error.status);
            } else {
                props.update(control.imageanalysisresponsekey ? control.imageanalysisresponsekey : (control.key + '_imageanalysis'), docairesponse, formid);
            }
            if (control.googleaioutputfileurl) {
                props.update(control.googleaioutputfileurl, response.outputfileurl, formid);
            }
            // }
        })
        .catch(err => {
            console.log(err);
        });
}
